import { GET_DMX_OCCUPANCY, GET_DMX_OCCUPANCY_SUCCESS, GET_DMX_OCCUPANCY_ERROR } from './actionTypes';

export const getDmxOccupancy = (user, universeId) => {
  return {
    type: GET_DMX_OCCUPANCY,
    payload: { user, universeId },
  };
};

export const getDmxOccupancySuccess = (devices) => {
  return {
    type: GET_DMX_OCCUPANCY_SUCCESS,
    payload: { devices },
  };
};

export const getDmxOccupancyError = (error) => {
  return {
    type: GET_DMX_OCCUPANCY_ERROR,
    payload: error,
  };
};
